type props = {
  source: string;
  width?: number;
  height?: number;
  location?: string;
};

export const addParamsToImageURL = ({
  source,
  location,
  width,
  height,
}: props) => {
  // Return empty string if source is empty or falsy
  // This prevents Next.js ImagePreload error with empty href
  if (!source) {
    return '';
  }

  // Parse existing URL to check for existing params
  const [baseUrl, existingQuery] = source.split('?');
  const existingParams = new URLSearchParams(existingQuery ?? '');

  // Only add params if they don't already exist in the URL
  if (location && !existingParams.has('location')) {
    existingParams.set('location', location);
  }
  if (width && !existingParams.has('width')) {
    existingParams.set('width', String(width));
  }
  if (height && !existingParams.has('height')) {
    existingParams.set('height', String(height));
  }

  const queryString = existingParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};
